import React from "react";
import { useParams } from "react-router-dom";
import FinancialStatement from "./FinancialStatement";
import { incomeStatementsData } from "../api/financialsData"; // Import the API call

export default function IncomeStatement() {
	const { symbol } = useParams();

	return (
		<FinancialStatement
			fetchDataFunction={incomeStatementsData}
			statement={"Income"}
			symbol={symbol}
		></FinancialStatement>
	);
}
